import request from '@/utils/request'

const cache = new Map()

/**
 * 在进入专题列表页前启动预取（分类 + 该分类下的专题），用于改善 LCP（div.card-summary）。
 * 在 router 即将导航到 /kb/series?categoryId=xxx 时调用。
 * @param {string} categoryId
 */
export function startKbSeriesListPrefetch(categoryId) {
  if (!categoryId || cache.has(categoryId)) return
  const categoriesPromise = request.get('/kb/categories').then((data) => (Array.isArray(data) ? data : [])).catch(() => [])
  const seriesPromise = request
    .get('/kb/series', {
      params: { current: 1, size: 20, categoryId, keyword: '' }
    })
    .then((data) => ({ records: data?.records ?? [], total: data?.total ?? 0 }))
    .catch(() => ({ records: [], total: 0 }))
  cache.set(categoryId, { categoriesPromise, seriesPromise })
}

/**
 * 取走预取结果（仅能消费一次），SeriesList 挂载时调用。
 * @param {string} categoryId
 * @returns {Promise<{ categories: any[], records: any[], total: number } | null>}
 */
export function takePrefetchedKbSeriesList(categoryId) {
  const entry = cache.get(categoryId)
  cache.delete(categoryId)
  if (!entry) return Promise.resolve(null)
  return Promise.all([entry.categoriesPromise, entry.seriesPromise]).then(([categories, { records, total }]) => ({
    categories,
    records,
    total
  }))
}
